/**
 * Short labels for catalog format cells — used only when the full word
 * does not fit (see CatalogFormatLabel).
 */
const CATALOG_FORMAT_SHORT: Record<string, string> = {
  compilation: 'Comp.',
  compilations: 'Comp.',
  collaboration: 'Collab.',
  collaborations: 'Collab.',
  featured: 'Feat.',
  feature: 'Feat.',
  remix: 'Rmx.',
  remixes: 'Rmx.',
  single: 'SP',
  singles: 'SP',
};

/** Short form if one exists; otherwise null (keep the full label). */
export function catalogFormatShort(
  label: string | undefined | null,
): string | null {
  const raw = (label ?? '').trim();
  if (!raw) return null;
  const short = CATALOG_FORMAT_SHORT[raw.toLowerCase()];
  return short && short !== raw ? short : null;
}
